<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="data.data"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="out_of_city" slot-scope="{ item }">
                {{ item.out_of_city | yesno }}
            </template>

            <template slot="end_date" slot-scope="{ item }">
                <div v-if="item.end_date">
                    {{ item.end_date | datetime }}
                </div>
                <div v-else>
                    Sin finalizar el servicio
                </div>
            </template>

            <template slot="start_date" slot-scope="{ item }">
                {{ item.start_date | datetime }}
            </template>

            <template slot="client_customer" slot-scope="{ item }">
                {{
                    !!item.client_customer
                        ? item.client_customer.name
                        : '-- N/A --'
                }}
            </template>

            <template slot="town" slot-scope="{ item }">
                {{ !!item.town ? item.town.name : '-- N/A --' }}
            </template>

            <template slot="actions" slot-scope="{ item }">
                <b-button
                    variant="primary"
                    size="sm"
                    @click="editService(item)"
                    v-if="isEditable(item)"
                    ><i class="fa fa-pencil"></i
                ></b-button>
                <b-button
                    v-if="!item.end_date && item.user.id === user.id"
                    size="sm"
                    variant="primary"
                    title="Ingresar al servicio"
                    @click="loginService(item)"
                    ><i class="fa fa-sign-in" aria-hidden="true"></i
                ></b-button>
                <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    title="Ver tarjeta del servicio"
                    @click="seeCardService(item)"
                    ><i class="fa fa-search-plus" aria-hidden="true"></i
                ></b-button>
                <b-button
                    v-if="item.user.id === user.id"
                    size="sm"
                    variant="danger"
                    title="Eliminar el servicio"
                    @click="removeService(item)"
                    ><i class="fa fa-trash"></i
                ></b-button>
            </template>
        </app-data-table>
    </div>
</template>
<script>
import fields from './fields'
import BodyguardServiceFormVehicular from '../BodyguardServiceForm/BodyguardServiceFormVehicular'
import BodyguardServiceFormPersonal from '../BodyguardServiceForm/BodyguardServiceFormPersonal'
export default {
    components: {
        appBodyguardServiceFormVehicular: BodyguardServiceFormVehicular,
        appBodyguardServiceFormPersonal: BodyguardServiceFormPersonal,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fields,
            selectedService: '',
            form: '',
        }
    },
    methods: {
        onChangePage(page) {
            this.$emit('change-page', page)
        },
        removeService(data) {
            this.$emit('remove-service', data)
        },
        loginService(data) {
            this.$emit('login-service', data)
        },
        seeCardService(data) {
            this.$emit('see-card-service', data)
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        isEditable(item) {
            if (item.user.id !== this.user.id) return false

            const startOfMonth = moment().startOf('month')
            const endOfMonth = moment().endOf('month')

            return moment(item.start_date).isBetween(startOfMonth, endOfMonth)
        },
        editService(service) {
            this.$emit('update', service)
        },
    },
}
</script>
